(function() {
    'use strict';

    angular
        .module('app',['ngRoute','ngSanitize','lr.upload','720kb.socialshare','angular-loading-bar','ngAnimate']).config(function($httpProvider) {
       		$httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
       		var getCookie = function(name) {
			    var cookieValue = null;
			    if (document.cookie && document.cookie !== '') {
			        var cookies = document.cookie.split(';');
			        for (var i = 0; i < cookies.length; i++) {
			            var cookie = jQuery.trim(cookies[i]);
			            // Does this cookie string begin with the name we want?
			            if (cookie.substring(0, name.length + 1) === (name + '=')) {
			                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
			                break;
			            }
			        }
			    }
			    return cookieValue;
			};

			var csrftoken = getCookie('csrftoken');
			$httpProvider.defaults.xsrfCookieName = 'csrftoken';
			$httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
        	$httpProvider.defaults.headers.post['X-CSRFToken'] = csrftoken;
     	    $httpProvider.defaults.timeout = 30000;

    	}).config(['$qProvider', function ($qProvider) {
    				$qProvider.errorOnUnhandledRejections(false);
		}]).config(['cfpLoadingBarProvider', function(cfpLoadingBarProvider) {
				    
    			cfpLoadingBarProvider.parentSelector = '#loading-bar-container';
    			cfpLoadingBarProvider.spinnerTemplate = '<i class="icon fa fa-circle-notch fa-spin mygreen"></i>';

		}]).run(function($rootScope,$location,userService){
				$rootScope.$on('$routeChangeStart', function($event, next, current) { 
   						// ... you could trigger something here ...
   						if(next){
   							if(next.auth===true)
   							{
   								if(!userService.islogged())
   									$location.path("/")
   							}
   						}
 				});
    			
		});
})();
